// JOBE-0044.4: ChipTextInput — the Phase-2 stand-in for the predicate
// picker popover (JOBE-0044.10). Inline text input after the last chip;
// accepts the friendly R4 tokens this subtask supports (per the
// `chipVocabulary` table). Unknown / deferred tokens surface a quiet
// "unrecognized · upgrade to filter picker (JOBE-0044.10)" hint.

import { useState } from 'react';
import { parseChipInput } from './chipVocabulary.js';

export function ChipTextInput({ onAppend }) {
  const [value, setValue] = useState('');
  const [hint, setHint] = useState(null);

  const submit = () => {
    const trimmed = value.trim();
    if (!trimmed) return;
    const parsed = parseChipInput(trimmed);
    if (!parsed) {
      setValue('');
      setHint(null);
      return;
    }
    if (parsed.kind === 'unrecognized') {
      setHint({
        token: parsed.token,
        reason: parsed.reason,
      });
      return;
    }
    onAppend(parsed);
    setValue('');
    setHint(null);
  };

  const onKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      submit();
    } else if (e.key === 'Escape') {
      setValue('');
      setHint(null);
    }
  };

  return (
    <span className="library-chip-input-wrap">
      <input
        type="text"
        className="library-chip-input"
        placeholder="type:briefing, by:iris, q:vendor obs…"
        value={value}
        onChange={(e) => { setValue(e.target.value); setHint(null); }}
        onKeyDown={onKeyDown}
        aria-label="Add filter"
      />
      <button
        type="button"
        className="library-chip-add-button"
        onClick={submit}
        aria-label="Add filter from text input"
      >
        Add from text
      </button>
      {hint && (
        <span className="library-chip-hint muted" role="status">
          unrecognized · upgrade to filter picker (JOBE-0044.10)
        </span>
      )}
    </span>
  );
}
